import {ChangeDetectorRef, Component, ElementRef, forwardRef} from "@angular/core";
import {NG_VALUE_ACCESSOR} from "@angular/forms";
import {FUIAbstractTimeInput} from "../abstract-time-input";
import {FUIEventsService} from "../../../../events/events.service";
@Component({
    providers: [
        {
            provide: NG_VALUE_ACCESSOR,
            useExisting: forwardRef(() => FUIFilterTimeInputComponent),
            multi: true
        }
    ],
    selector: "fui-filter-time-input",
    styleUrls: ["./filter-time-input.component.scss"],
    templateUrl: "./filter-time-input.component.html",
    standalone: false
})
export class FUIFilterTimeInputComponent extends FUIAbstractTimeInput {
    constructor(elementRef: ElementRef,
                changeDetectorRef: ChangeDetectorRef,
                eventsService: FUIEventsService) {
        super(elementRef, changeDetectorRef, eventsService);
    }
}
